var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Condities")]),
      _c(
        "w-scroll-view",
        { style: { flexGrow: 1, flexShrink: 1 } },
        [
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-multi-select", {
                        attrs: {
                          label:
                            "Verkoop types (Leeg laten indien niet gebruikt wordt)",
                          items: _vm.saleTypeItems,
                        },
                        model: {
                          value: _vm.setting.SaleTypeFilter,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "SaleTypeFilter", $$v)
                          },
                          expression: "setting.SaleTypeFilter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-multi-select", {
                        attrs: {
                          label:
                            "Btw regimes (Leeg laten indien niet gebruikt wordt)",
                          items: _vm.vatRegimeTypeItems,
                        },
                        model: {
                          value: _vm.setting.VatRegimeFilter,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "VatRegimeFilter", $$v)
                          },
                          expression: "setting.VatRegimeFilter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-card-title", [
            _vm._v(" Check functie (Leeg laten indien niet gebruikt wordt) "),
          ]),
          _c("codemirror", {
            ref: "codeEditor",
            staticClass: "grow",
            attrs: { options: _vm.cmOptions },
            model: {
              value: _vm.setting.ShouldRunScript,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "ShouldRunScript", $$v)
              },
              expression: "setting.ShouldRunScript",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v("Bevestigen")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }